import { render } from "./SpecificationList.vue?vue&type=template&id=66c6e1fe"
import script from "./SpecificationList.vue?vue&type=script&lang=js"
export * from "./SpecificationList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__